import { ReactNode } from 'react'

import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
} from 'client/semantic-imports'

import AppParagraph from '../AppParagraph/app-paragraph'
import AppDivider from '../AppDivider/app-divider'

import './app-table.scss'

type Props = {
  columns: string[]
  rows: object[]
  mapValue?: (rowData: object, colName: string) => ReactNode
  Footer?: ReactNode
  showRowNo?: boolean
  hideHeader?: boolean
}

const AppTable = ({
  columns,
  rows,
  mapValue = (rowData, colName) => <>{rowData[colName]}</>,
  Footer = null,
  showRowNo = false,
  hideHeader = false,
}: Props) => (
  <div className="appTable">
    <Table celled>
      {!hideHeader ? (
        <TableHeader>
          <TableRow>
            {showRowNo ? <TableHeaderCell key="no">no</TableHeaderCell> : null}
            {columns.map(colName => (
              <TableHeaderCell key={colName}>{colName}</TableHeaderCell>
            ))}
          </TableRow>
        </TableHeader>
      ) : null}
      <TableBody>
        {rows.map((row, i) => (
          <TableRow key={i}>
            {showRowNo ? <TableCell key={`no_${i}`}>{i + 1}</TableCell> : null}
            {columns.map((colName, j) => (
              <TableCell key={`${colName}_${i}_${j}`}>{mapValue(row, colName)}</TableCell>
            ))}
          </TableRow>
        ))}
        {!rows.length ? (
          <TableRow>
            <TableCell colSpan={columns.length}>
              <AppDivider />
              <AppParagraph size="medium" text="Nothing to display" centered />
              <AppDivider />
            </TableCell>
          </TableRow>
        ) : null}
      </TableBody>
      {Footer ? (
        <TableFooter>
          <TableRow>
            <TableHeaderCell colSpan={showRowNo ? columns.length + 1 : columns.length}>
              {Footer}
            </TableHeaderCell>
          </TableRow>
        </TableFooter>
      ) : null}
    </Table>
  </div>
)

export default AppTable
